function initialiseHorizontalScroll(component) {
    if (component.dataset.horizontalScrollInitialised === 'true') {
        return;
    }

    const track = component.querySelector('[data-horizontal-scroll-track]');
    const controls = component.querySelector('[data-horizontal-scroll-controls]');
    const progress = component.querySelector('[data-horizontal-scroll-progress]');
    const previous = component.querySelector('[data-horizontal-scroll-previous]');
    const next = component.querySelector('[data-horizontal-scroll-next]');

    if (!track || !controls || !progress || !previous || !next) {
        return;
    }

    const scroller = track.querySelector('.widget-zone') || track;
    const itemSelector = component.dataset.horizontalScrollItemSelector;
    const getItems = () => (itemSelector ? Array.from(scroller.querySelectorAll(itemSelector)) : []);
    const desktopMediaQuery = window.matchMedia('(min-width: 992px)');

    const updateControls = () => {
        const items = getItems();
        const isStaticDesktopGrid = desktopMediaQuery.matches && items.length <= 3;

        component.classList.toggle('modern-card-content-widget--static', isStaticDesktopGrid);

        const maximumScroll = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
        const currentScroll = Math.min(Math.max(scroller.scrollLeft, 0), maximumScroll);
        const initialProgress = items.length ? 1 / items.length : 1;
        const scrollProgress = maximumScroll > 1 ? currentScroll / maximumScroll : 1;
        const progressValue = initialProgress + (scrollProgress * (1 - initialProgress));

        progress.style.width = `${Math.min(Math.max(progressValue, 0), 1) * 100}%`;
        controls.hidden = isStaticDesktopGrid || maximumScroll <= 1;
        previous.disabled = currentScroll <= 1;
        next.disabled = currentScroll >= maximumScroll - 1;
    };

    const scrollItems = direction => {
        const items = getItems();
        const gap = parseFloat(window.getComputedStyle(scroller).columnGap) || 0;
        const itemStep = items.length ? items[0].getBoundingClientRect().width + gap : scroller.clientWidth;

        scroller.scrollBy({ left: direction * itemStep, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollItems(-1));
    next.addEventListener('click', () => scrollItems(1));
    scroller.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);

    if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(scroller);
    }

    if ('MutationObserver' in window) {
        new MutationObserver(updateControls).observe(scroller, { childList: true, subtree: true });
    }

    component.dataset.horizontalScrollInitialised = 'true';
    updateControls();
}

function initialiseAllHorizontalScrolls() {
    document.querySelectorAll('.js-horizontal-scroll').forEach(initialiseHorizontalScroll);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAllHorizontalScrolls);
} else {
    initialiseAllHorizontalScrolls();
}

if ('MutationObserver' in window) {
    new MutationObserver(initialiseAllHorizontalScrolls)
        .observe(document.documentElement, { childList: true, subtree: true });
}
